import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-screen-lg m-auto font-extralight"
}
const _hoisted_2 = { class: "mx-4 md:mt-12" }
const _hoisted_3 = { class: "grid grid-cols-1 md:gap-4 md:grid-cols-3 px-4 md:px-0" }
const _hoisted_4 = { class: "col-span-2 relative" }
const _hoisted_5 = { class: "w-full md:max-w-lg m-auto" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"100%"} }, null, -1)
const _hoisted_7 = { class: "absolute w-full h-full md:max-w-lg top-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "text-center my-4"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-8 w-8 top-6 left-6 absolute text-brand",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_13 = { class: "flex mb-0 mt-4 items-center justify-center" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "flex-1 text-right text-2xl" }
const _hoisted_16 = { class: "flex mb-8 mt-0 items-center justify-center" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { class: "flex-1 text-right text-2xl" }
const _hoisted_19 = {
  key: 1,
  class: "flex mb-8 mt-4 items-center justify-center"
}
const _hoisted_20 = { class: "flex-1" }
const _hoisted_21 = { class: "flex-1 text-right text-3xl" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { class: "text-justify leading-7 my-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_video3d = _resolveComponent("item-video3d")!
  const _component_item_configuration = _resolveComponent("item-configuration")!
  const _component_element_button = _resolveComponent("element-button")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.item.slug != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.curImage === 'main')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.item.obj.getImage(),
                          class: "w-full",
                          alt: ""
                        }, null, 8, _hoisted_8))
                      : (_ctx.curImage === '3d')
                        ? (_openBlock(), _createBlock(_component_item_video3d, {
                            key: 1,
                            "video-set-id": _ctx.video3dSetId,
                            class: "w-full shadow-md",
                            style: {"margin-top":"25%"}
                          }, null, 8, ["video-set-id"]))
                        : _createCommentVNode("", true)
                  ]),
                  (_ctx.video3dSetId !== '')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                        _createElementVNode("li", {
                          class: _normalizeClass([{ 'border-brand-promo-bg': _ctx.curImage === 'main' }, "relative list-none inline-block border-b border-white w-20 mx-4 cursor-pointer"]),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.curImage = 'main'))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.item.obj.getImage(),
                            class: "w-20 h-20",
                            alt: ""
                          }, null, 8, _hoisted_10)
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass([{ 'border-brand-promo-bg': _ctx.curImage === '3d' }, "relative list-none inline-block border-b border-white w-20 mx-4 cursor-pointer"]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.curImage = '3d'))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.item.obj.getImage(),
                            class: "w-20 h-20",
                            alt: ""
                          }, null, 8, _hoisted_11),
                          _hoisted_12
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                (
                _ctx.country === 'us' &&
                _ctx.item.obj.getJewelleryType() === 'weddingRing' &&
                _ctx.item.obj.getItemPrices(2) > 0 &&
                _ctx.item.obj.getItemPrices(3) == 0
              )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.pageStr + ".price.women")), 1),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$n(_ctx.item.obj.getItemPrices(1), "currency")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t(_ctx.pageStr + ".price.men")), 1),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$n(_ctx.item.obj.getItemPrices(2), "currency")), 1)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t(_ctx.pageStr + ".price.item" + _ctx.item.obj.getNumberOfItems())), 1),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$n(_ctx.item.obj.getPrice(), "currency")), 1)
                    ])),
                _createVNode(_component_item_configuration, {
                  "item-obj": _ctx.item.obj,
                  "page-str": _ctx.pageStr,
                  "loading-sessions": _ctx.loadingSessions
                }, null, 8, ["item-obj", "page-str", "loading-sessions"]),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.configuratorLink)
                    ? (_openBlock(), _createBlock(_component_element_button, {
                        key: 0,
                        link: _ctx.linkConfigurator + '#' + _ctx.item.obj.getSlug()
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.pageStr + ".cta.configure")), 1)
                        ]),
                        _: 1
                      }, 8, ["link"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.pageStr + ".setId")) + ": " + _toDisplayString(_ctx.item.obj.getItemnumber()) + " - " + _toDisplayString(_ctx.$t(_ctx.pageStr + ".jewelleryType." + _ctx.item.obj.getJewelleryType())) + " " + _toDisplayString(_ctx.$t(_ctx.pageStr + ".in")) + " " + _toDisplayString(_ctx.item.obj.getDescription("metal")) + " " + _toDisplayString(_ctx.item.obj.getDescription("profile")) + " ", 1),
                    (_ctx.item.obj.getDescription('stone'))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.pageStr + ".with")) + " " + _toDisplayString(_ctx.item.obj.getDescription("stone")["text"]), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.linkAppointment)
                    ? (_openBlock(), _createBlock(_component_element_button, {
                        key: 1,
                        "inverse-style": "true",
                        link: _ctx.linkAppointment
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.pageStr + ".cta.appointment")), 1)
                        ]),
                        _: 1
                      }, 8, ["link"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}